import { ReviewStatus } from '../../../../extViewmodels';

/**
 * Checks if the given review status is enabled on the account
 * @param account The user account with features
 * @param status The ReviewStatus to check
 * @returns True if the status is enabled, false otherwise
 */
export function isReviewStatusEnabled(account: any, status: ReviewStatus): boolean {
	switch (status) {
		case ReviewStatus.PreApproved:
			return !!account?.features?.templateReviewSettings?.preApproved?.enabled;
		case ReviewStatus.PreReviewed:
			return !!account?.features?.templateReviewSettings?.preReviewed?.enabled;
		case ReviewStatus.Rejected:
			return !!account?.features?.templateReviewSettings?.rejected?.enabled;
		default:
			return false;
	}
}

/**
 * Gets the enabled review status for the account
 * @param account The user account with features
 * @returns The enabled ReviewStatus (PreApproved or PreReviewed) or null if none are enabled
 */
export function getEnabledReviewApprovalStatus(account: any): ReviewStatus | null {
	if (isReviewStatusEnabled(account, ReviewStatus.PreApproved)) {
		return ReviewStatus.PreApproved;
	} else if (isReviewStatusEnabled(account, ReviewStatus.PreReviewed)) {
		return ReviewStatus.PreReviewed;
	}
	return null;
}
